import React from 'react';
import { Badge } from '@chakra-ui/react';

const SiblingDiscountBadge = ({ size = 'xs', ...props }) => (
  <Badge
    colorScheme="purple"
    borderRadius="10px"
    px={3}
    py={1}
    fontSize={size}
    fontWeight="600"
    {...props}
  >
    Sconto fratelli
  </Badge>
);

export function orderHasSiblingDiscount(order) {
  return Boolean(
    order?.metadata?.products?.some((product) => product.applyDiscount === true)
  );
}

export default SiblingDiscountBadge;
